// Single source of truth for the app version shown top-right on every screen.
// Bump this on each new development iteration (1.1 -> 1.2 -> ...).
export const APP_VERSION = "3.1";
